<template>
  <div class="login h100">
    <!-- <h1>This is an login page</h1> -->
    <div class="login_box">
      <!-- 登录表单区域 -->
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form">
        <h2 style="text-align:center;color:#444">欢迎登录</h2>
        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input v-model="loginForm.account" prefix-icon="el-icon-user-solid"></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password"></el-input>
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item class="btns">
          <el-button type="primary" @click="login()">登录</el-button>
          <el-button type="info" @click="resetLoginForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import AES from '@/utils/aes'
export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        account: 'zhangqiang.wu@123.com',
        password: '111111'
      },
      loginFormRules: {
        // 验证用户
        account: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: ['blur'] }
        ],
        // 验证密码
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created () {},
  methods: {
    // 重置登录
    resetLoginForm () {
      this.$refs.loginFormRef.resetFields()
    },
    // 登录
    login () {
      this.$refs.loginFormRef.validate(async valid => {
        if (valid) {
          // let loginForm = {
          //   account: AES.encrypt(this.loginForm.account),
          //   password: AES.encrypt(this.loginForm.password)
          // }
          this.$http.post(this.API.login, this.loginForm).then(res => {
            // console.log(res)
            let data = res.data
            if (data.code === 200) {
              sessionStorage.setItem('userInfo', JSON.stringify(data.data.userInfo))
              sessionStorage.setItem('token', data.data.token)
              // 跳转到主页面
              // this.$router.push('/home')
              // 跳转到选择角色页面
              this.$router.push('/loginRole')
              this.$message.success('登录成功！')
            } else {
              this.$message.error('用户名密码错误！')
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  background: url("../../assets/logo_bg1.png") no-repeat center center / 100% 100%;
  background-color: #F0EFED;
  .login_box {
    width: 500px;
    height: 300px;
    background-color: #fafafa;
    border-radius: 5px;
    position: absolute;
    // bg
    // left: 50%;
    // top: 35%;
    // opacity: 0.8;
    // bg2
    left: 50%;
    top: 50%;
    opacity: 0.8;
    transform: translate(-50%, -50%);
    border: 1px solid #e0e0e0;
    .login_form {
      position: absolute;
      bottom: 15px;
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      .btns {
        display: flex;
        justify-content: flex-end;
      }
    }
    /deep/ .el-input__icon {
      font-size: 18px
    }
  }
}
</style>
